<template>
  <div class="w-100">
        <div class=" p-list-representation-wrapper align-items-start">
          <Loader class="w-100" :loading="loading">
            <div  class="w-100p-list-representation-content row mr-auto ml-auto align-items-start">
              <div class="w-100" >
                <appHeader></appHeader>
              </div>

              <div class=" row p-list-representation-data w-100">
                <contentList
                  :form-data="formData"
                  @submitForm="submitForm"


                ></contentList>
              </div>

            </div>
          </Loader>

        </div>

  </div>
</template>

<script>
import contentList from '../components/entryAndEditListSalonOwner/contentList';
import appHeader from '../components/includes/AppHeader';



export default {
  name: "entryAndEditListSalonOwner",
  components: {
    contentList,
    appHeader,
  },

  props: {

  },

  data() {
    return {
      loading       : false,
      formData      : {
            nameFamily              : '',
            name                    : '',
            family                  : '',
            shaba_code              : '',
            bank_name               : '',
            bank_owner_name         : '',
            national_card           : {},
            city_id                 : 296,
            province_id             : 21,
            mobile                  : '',
            national_code           : '',
            include_credit          : 1,
            name                    : '',
            family                  : '',

      },

    }
  },

  watch: {

  },

  created() {
    const checkSingleSalon = this.$route.query;
    if (typeof(checkSingleSalon) != 'undefined') {
      for (let key in checkSingleSalon) {
        this.formData[key] = checkSingleSalon[key]
      }
      // this.splitNameFamilyThenCombileInToNameFamily();
    }
  },

  mounted() {
  },

  methods: {
    // splitNameFamilyThenCombileInToNameFamily(){
    //   const family = this.formData.family;
    //   const name   = this.formData.name;
    //
    //   this.formData.nameFamily = `${name} ${family}`
    // },

    submitForm(data){
      this.formData           = data;
      this.loading            = true;

      this.$store
      .dispatch('entryAndEditListSalonOwner/editListSalonOwner', {
        data : {
          ...this.formData,
        }
      })
      .then((res)=>{
        this.loading   = false;

        if (res.is_successful) {
          this.$message.success(res.message);
          this.$router.push({name:'listSalonOwner'})
        }
        else {
          if (typeof(res.is_successful) != 'undefined') {
            let concatMessage = '';
            for (let key in res.message) {
              const contentError = res.message[key];
              concatMessage+=contentError + ',';
            }
            this.$message.error(concatMessage)
          }

        }

      })
    }

  }


}
</script>
